export const MenuItems = [
  { name: "home", to: "/movies-api/" },
  { name: "Tv Shows", to: "/movies-api/shows" },
  { name: "Movies", to: "/movies-api/movies" },
  { name: "Upcoming", to: "/movies-api/upcoming" },
];
